export default "__VITE_ASSET__Bz5Poq38__"